import * as React from 'react';
import { DefaultButton, PanelType, PrimaryButton } from "@fluentui/react";
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {SpinButton, Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import NetGrossPicker from "../../Components/NetGrossPicker";
import { MoneyFormat } from "../../Utilities/MoneyFormat";

function EditAgreementElement(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [note, setNote] = useState('');
    const [net, setNet] = useState('0');
    const [vat, setVat] = useState('0');
    const [gross, setGross] = useState('0');
    const [quantity, setQuantity] = useState('1');

    const _submit = (e) => {
        e.preventDefault();
        const data = {name: name, note: note,
            net_value: net, vat: vat, gross_value: gross, quantity: quantity
        };
        fetch(`/api/agreement/element/${props.add.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditCostAddon'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        if (props.add) {
            setNote(props.add.note);
            setName(props.add.name);
            setNet(props.add.net_value);
            setVat(props.add.vat);
            setGross(props.add.gross_value);
            setQuantity(props.add.quantity);
        }
    }, [props.add])

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Przypisany Koszt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
            type={PanelType.largeFixed}
        >
            <form onSubmit={_submit} id='EditCostAddon'>
                <TextField maxLength={160} label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField multiline maxLength={255} label='Notatka' value={note} onChange={(e) => setNote(e.target.value || '')}/>
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <SpinButton
                    label={'Ilość'}
                    labelPosition={'top'}
                    min={0}
                    step={0.01}
                    max={10000000}
                    incrementButtonAriaLabel={'+1'}
                    decrementButtonAriaLabel={'-1'}
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value || '')}
                />
                <h4>Razem: {MoneyFormat(parseFloat(quantity) * parseFloat(net))} netto, {MoneyFormat(parseFloat(quantity) * parseFloat(gross))} brutto</h4>
            </form>
        </Panel>
    )
}

export default EditAgreementElement;